<template>
  <div class="page">
    <div
      class="row"
      style="height: 100%"
    >
      <div class="col wifi-login-form pt-5">
        <spotley-header/>
        <div class="row">
          <div class="col col-11 mx-auto">
            <reset-password-form/>
          </div>
        </div>
      </div>
      <div class="col wifi-login-rightView"></div>
    </div>
  </div>
</template>

<script>
import resetPasswordForm from '@/components/resetPasswordForm.vue';
import spotleyHeader from '@/components/spotleyHeader.vue';

export default {
  name: 'login',
  components: {
    spotleyHeader,
    resetPasswordForm,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_globals.scss";
@import "@/assets/scss/wifi-forms.scss";
</style>
